module.exports = __webpack_public_path__ + "static/media/spin@2x.74617bb8.png";